<template>
    <BaseModal :title="title" white v-on="$listeners">
        <div class="lsva-changelog-modal" v-html="changes" />
    </BaseModal>
</template>

<script>
import marked from 'marked'

import BaseModal from '@/components/redesigned/BaseModal'

import changelogDe from 'raw-loader!../../assets/notifications/lsva_changelog_de.md'
import changelogEn from 'raw-loader!../../assets/notifications/lsva_changelog_en.md'
import changelogFr from 'raw-loader!../../assets/notifications/lsva_changelog_fr.md'
import changelogIt from 'raw-loader!../../assets/notifications/lsva_changelog_it.md'

const changelogMap = {
    de: changelogDe,
    en: changelogEn,
    fr: changelogFr,
    it: changelogIt,
}

const signatureMap = {
    mobatime: 'Mobatime',
    axroad: 'adnexo',
}

export default {
    name: 'LsvaChangesModal',
    components: {
        BaseModal,
    },
    props: {
        showActions: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            changelog: null,
            loadingChangelog: false,
        }
    },
    computed: {
        changes() {
            const replacedMdContent = (
                this.changelog ||
                changelogMap[this.$i18n.locale] ||
                changelogMap.de
            )
                .replaceAll(
                    '${instance}',
                    signatureMap[process.env.VUE_APP_INSTANCE] ||
                        signatureMap.axroad
                )
                .replaceAll(
                    '${mail}',
                    process.env.VUE_APP_SUPPORT_EMAIL || 'support@adnexo.ch'
                )
            return marked(replacedMdContent, {
                sanitized: true,
            })
        },
        title() {
            return `${this.$t('changelogTitle')}: ${
                process.env.VUE_APP_VERSION
            }`
        },
    },
    async mounted() {
        this.loadingChangelog = true
        const lang = this.$i18n.locale || 'de'
        const subDirPath = process.env.VUE_APP_SUB_DIR_PATH
        const rootPath = subDirPath ? `/${subDirPath}` : ''
        fetch(`${rootPath}/changelogs/lsva_changelog_${lang}.md`, {
            cache: 'no-store',
        })
            .then(response => response.text())
            .then(text => {
                this.changelog = text
            })
            .finally(() => {
                this.loadingChangelog = false
            })
    },
}
</script>

<i18n>
{
    "en": {
        "changelogTitle": "Change to the display in the HVC outage solution",
        "close": "Close"
    },
    "de": {
        "changelogTitle": "Änderung der Darstellung in der LSVA Ausfalllösung",
        "close": "Schliessen"
    },
    "fr": {
        "changelogTitle": "Changement de l'affichage dans la solution de secours LSVA",
        "close": "Fermer"
    },
    "it": {
        "changelogTitle": "# Modifica della visualizzazione nella soluzione di fallback TTPCP",
        "close": "Chiudere"
    }
}
</i18n>

<style lang="scss">
.lsva-changelog-modal {
    p,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        margin-bottom: 16px;
    }
    li {
        margin-bottom: 8px;
    }
}
</style>
